import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Form, Image, Row, Table } from 'react-bootstrap'
import Select from 'react-select'
import { ClientService } from '../../component/services/client.service';
import moment from 'moment';
import toast from 'react-hot-toast';
import TablePaginationComponent from '../../component/table/TablePagination';
import PreviewModal from '../../component/modals/Preview.modal';
import { saveAsCSV } from '../../component/helpers/csvhelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import FiltersComponent, { FilterOption } from '../../component/Filters/FiltersComponent';
import { ClientServiceV2 } from '../../component/services/client.service.v2';

export default function BiometricOperatorStatsIndex() {
    const [shifts, setShifts] = useState<any>();
    const [selectValue, setSelectValue] = useState<any>();
    const [pageSize, setPageSize] = useState<number>(10);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalCount, setTotolCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);

    const [selectedFilters, setSelectedFilters] = useState<{
        states: FilterOption[];
        zones: FilterOption[];
        districts: FilterOption[];
        centers: FilterOption[];
    }>({
        states: [],
        zones: [],
        districts: [],
        centers: [],
    });

    const handleFiltersChange = (filters: any) => {
        setSelectedFilters(filters);
    };


    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id,
                        startTime: data.startTime,
                        endTime: data.endTime
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    const getExceptionReport = async () => {
        if (!selectValue) {
            toast.error("Please select a shift");
            return;
        }
        let payload = {};
        if (selectedFilters?.centers?.length > 0) {
            payload = { ...payload, centerId: selectedFilters.centers.map((center: any) => center.value) }
        }
        if (selectedFilters?.states?.length > 0) {
            payload = { ...payload, state: selectedFilters.states?.map((state: any) => state.value) }
        }
        if (selectedFilters?.districts?.length > 0) {
            payload = { ...payload, city: selectedFilters.districts?.map((district: any) => district.value) }
        }
        if (selectedFilters?.zones?.length > 0) {
            payload = { ...payload, zone: selectedFilters.zones?.map((zone: any) => zone.value) }
        }

        setLoading(true)
        await ClientServiceV2.getBiometricStats(selectValue, pageSize, pageNumber, payload)
            .then((res) => {
                if (res.status === 200) {

                    setTableData(res.data?.center_data || []);
                    setTotolCount(res.data?.totalCenters || 0);
                }
            })
            .catch((err) => {
                toast.error(err.response?.data || "An error occurred");
            });
        setLoading(false)
    };


    useEffect(() => {
        if (selectValue) {
            getExceptionReport();
        }
    }, [pageNumber, pageSize, selectedFilters]);


    useEffect(() => {
        getAllShift();
    }, [])

    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={4}>
                    <h4 className="fw-bold">Operator Report</h4>
                </Col>
                <Col md={4}></Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectValue(e?.value)}
                        isClearable
                        value={selectValue ? shifts.find((shift: any) => shift.value === selectValue.value) : null}
                    />
                </Col>
            </Row>


            <FiltersComponent
                selectedShift={selectValue}
                onFiltersChange={handleFiltersChange}
            />


            <Row>
                <Col>
                    <Card
                        className="mt-3"
                        style={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "12px",
                            border: "none",
                        }}
                    >
                        <Card.Body>
                            <div className="d-flex align-items-center  justify-content-end ">
                                <FontAwesomeIcon icon={faRefresh} className='m-2 cursor-pointer' onClick={getExceptionReport} />
                            </div>
                            <Table striped hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: 14 }}>Sr. No</th>
                                        <th style={{ fontSize: 14 }}>Venue Id</th>
                                        <th style={{ fontSize: 14 }}>Venue Name</th>
                                        <th style={{ fontSize: 14 }}>Total</th>
                                        {/* <th style={{ fontSize: 14 }}>Logged In</th> */}
                                        <th style={{ fontSize: 14 }}>Completed </th>
                                        <th style={{ fontSize: 14 }}>In Progress</th>
                                        <th style={{ fontSize: 14 }}>Pending</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loading ? (
                                            <tr>
                                                <td colSpan={8} className="text-center">Loading...</td>
                                            </tr>
                                        ) : tableData && tableData.length > 0 ? (
                                            tableData.map((data: any, index: number) => {
                                                return (
                                                    <tr>
                                                        <td style={{ fontSize: 12 }}>{pageNumber === 1 ? index + 1 : (pageNumber - 1) * pageSize + index + 1}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.centerName || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.centerId || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.totalInvigilators || "--"}</td>
                                                        {/* <td style={{ fontSize: 12 }}>{data?.loggedInInvigilators || "--"}</td> */}
                                                        <td style={{ fontSize: 12 }}>{data?.completedInvigilators || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.inProgressInvigilators || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.pendingInvigilators || "--"}</td>
                                                    </tr>
                                                )
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={15} className="text-center">No data available</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <TablePaginationComponent
                        currentPage={pageNumber}
                        itemsCount={totalCount}
                        itemsPerPage={pageSize}
                        setItemsPerPage={(e: any) => setPageSize(e)}
                        setCurrentPage={setPageNumber}
                    />
                </Col>
            </Row>
        </>
    )
}
